import { IconButton, IconButtonProps } from '@mui/material';
import React, { FC } from 'react';

import { Icon } from '../Icon';

interface TogglePasswordLegibilityProps extends IconButtonProps {
  legible: boolean;
}

export const TogglePasswordLegibility: FC<TogglePasswordLegibilityProps> = ({
  legible,
  ...props
}) => {
  return (
    <IconButton
      aria-label="toggle password visibility"
      title={legible ? 'Hide password' : 'Show password'}
      edge="end"
      {...props}
    >
      <Icon name={legible ? 'HideS' : 'ShowS'} />
    </IconButton>
  );
};
